(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.now_tab_page = {
    attach: function(context, settings) {
      /**
       *  Emulate a button / link, but actually click the title link.
       * This removes the redundancy of each element being a link,
       * and allows more flexibility with individual elements.
       */
      const $tabs = jQuery('.field--name-field-tabs a', context);
      const tabPageInit = function() {
        const url = window.location.href.split('/');
        const url_last_segment = url[url.length - 1];

        $tabs.each(function() {
          let $href = jQuery(this).attr('href').split('/');
          let $last_segment = $href[$href.length - 1];
          if ($last_segment === url_last_segment) {
            jQuery(this).addClass('is-active');
          }
        });
      };
      tabPageInit();
    }
  };
})(jQuery, Drupal);
